export const normalizeBic = (bic: number) => {
  return String(bic).padStart(9, '0');
};
